<template>
  <img
    class="object-cover"
    src="@/assets/images/emojis/emoji-money.png"
  >
</template>